export default __webpack_public_path__ + "static/media/playstore-light.e1e9239c.webp";